var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconLockGreen = function SvgIconLockGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.664 15.416H8.331c-.92 0-1.667.746-1.667 1.667v17.083c0 .92.746 1.667 1.667 1.667h23.333c.92 0 1.667-.746 1.667-1.667V17.083c0-.92-.747-1.667-1.667-1.667Z",
    fill: "#4BD667"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.353 25.364a1.354 1.354 0 0 0-2.709 0v2.76a1.354 1.354 0 0 0 2.709 0v-2.76Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.999 26.354a2.292 2.292 0 1 0 0-4.583 2.292 2.292 0 0 0 0 4.583Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.997 4.166a7.09 7.09 0 0 0-7.083 7.083v6.477a1.838 1.838 0 0 0 3.675 0V11.25c0-1.88 1.53-3.41 3.41-3.41 1.882 0 3.41 1.53 3.41 3.41v6.477a1.838 1.838 0 0 0 3.676 0V11.25a7.09 7.09 0 0 0-7.083-7.083h-.005Z",
    fill: "#4BD667"
  })));
};
export default SvgIconLockGreen;